import { mergeDeep } from '@/plugins/mergeDeep';
import Vue from 'vue';
const originState = {
  isModalOpen: false,
  single: false,
  title: null,
  content: null,
  cancel: {
    text: '取消',
    callback: () => {},
    loadingState: false,
    color: 'neutral100',
    bind: {}
  },
  action: {
    text: '確認',
    callback: () => {},
    loadingState: false,
    color: 'primary',
    bind: {}
  },
};

export default {
  namespaced: true,
  state: () => ({
    isModalOpen: false,
    /* props below */
    single: false,
    title: null,
    content: null,
    cancel: {
      text: '取消',
      callback: () => {},
      loadingState: false,
      color: '',
      bind: {}
    },
    action: {
      text: '確認',
      callback: () => {},
      loadingState: false,
      color: 'primary',
      bind: {}
    },
    close: {
      callback: () => {}
    }
  }),

  mutations: {
    setModalProps(state, props = {}) {
      Object.keys(props).forEach((key) => {
        switch (key) {
          case 'cancel':
            Vue.set(
              state,
              key,
              mergeDeep(
                {
                  text: '取消',
                  callback: () => {},
                  loadingState: false,
                  color: '',
                  bind: {}
                },
                props[key]
              )
            );
            break;

          case 'action':
            Vue.set(
              state,
              key,
              mergeDeep(
                {
                  text: '確認',
                  callback: () => {},
                  loadingState: false,
                  color: 'primary',
                  bind: {}
                },
                props[key]
              )
            );
            break;
          case 'close':
            Vue.set(
              state,
              key,
              mergeDeep(
                {
                  callback: () => {},
                },
                props[key]
              )
            );
            break;
          default:
            Vue.set(state, key, props[key]);
            break;
        }
      });
    },
    resetModal(state) {
      Object.keys(originState).forEach((key) => {
        Vue.set(state, key, originState[key]);
      });
      state.close.callback();
    }
  },

  actions: {
    ACTIVE_MODAL({ state, commit }, props) {
      commit('setModalProps', {
        isModalOpen: true,
        ...props
      });
    },
    CLOSE_MODAL({ commit }) {
      commit('resetModal');
    }
  }
};
